export default __webpack_public_path__ + "static/media/chairman.21c0906f.jpeg";